export const svgGridSize = 15;

//Bezier tool related UI constants
// bezierPreviewAnimationDensity and bezierPreviewAnimationDurationMultiplier ratio guarantees a 1 second default animation.
// bezierPreviewAnimationDensity is the number of points used to draw the preview animation.
// if one is changed, the other must be changed to compensate.
export const bezierPreviewAnimationDensity = 40;
export const bezierPreviewAnimationDurationMultiplier = 24.39;

//Bounce tool ui related constants
export const displayBounceDurationDefault = 4000; // TODO: consider using AE keyframe time delta here instead.
export const defaultBounceElasticity = 50;
export const defaultBounceGravity = 50;
export const defaultNumBounces = 10;
export const defaultBounceHang = 75;
export const defaultBounceVelocity = 50;
// if bounce peak is > height*bounceScalingCutoff, create new bounce
// all bounces are built in AE as percentages of their time and value deltas
export const bounceScalingCutoff = 0.002;
export const defaultDecayX = 1;
export const defaultDecayY = 50;

// ****** Elastic tool ui related constants
export const defaultElasticElasticityMax = 150;
export const defaultElasticElasticityMin = 100;
export const defaultElasticElasticity = 100;
// Decay
export const defaultElasticDecayMaxX = 100;
export const defaultElasticDecayMinX = 1;
export const defaultElasticDecayX = 25;
export const defaultElasticDecayMaxY = 100;
export const defaultElasticDecayMinY = 10;
export const defaultElasticDecayY = 50;
// Hang
export const defaultElasticHang = 50;
export const defaultElasticHangMax = 100;
export const defaultElasticHangMin = 1;
// Duration
export const defaultElasticGravity = 60;
export const defaultElasticGravityMax = 120;
export const defaultElasticGravityMin = 1;
// Amplitude
export const defaultElasticVelocityMax = 100;
export const defaultElasticVelocityMin = 1;
export const defaultElasticVelocity = 50;

export const elasticSegmentSearchMax = 50;
export const displayElasticDurationDefault = 4000; // TODO: consider using AE keyframe time delta here instead.

export const displayGridIncrement = 35;
